// Slide decks associated with Software Systems Capstone (SSC) sprint 3

import { list49200Sprint02 } from '../ActivityLists/AL49200Sprint02'
import { list49200Sprint03 } from '../ActivityLists/AL49200Sprint03'

import { xyz_n_1of4 } from './SL00000Sprint00TTR'
import { orderedListSlide } from './SLSprint00'
import { tLab } from './SL00000Sprint00'
import { renderCalendar, renderFinalExamTimes } from './images/2025-08-fall/render-image'

// Software Systems Capstone (SSC) sprint 3 values.
const sprint = 3
const activityList = () => { return list49200Sprint03(sprint) }
const activityListPrevious = () => { return list49200Sprint02(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

const ssc_3_1of2 = () => { 
	const sprintPlanningExpectations = () => {
		return orderedListSlide('Sprint Planning', 'Sprint 3 Expectations:', [
			'Similar to other sprints with Discussion, Writing Assignment, Lab, and Reflection',
			`Similar in that we will have two weeks to complete all sprint ${sprint} assignments`,
			`Similar in that you will meet with your team in-person** next Tuesday` ])
	}
	return xyz_n_1of4(null, ssc_3_2of2_PAaA, sprintAndActivityLists, sprintPlanningExpectations)
}
	
const ssc_3_2of2_PAaA = {
	'prework':[
		'Be prepared for sprint 4 planning', '',
		'' ],
	'announcements':[ ],
	'agenda':[ ],
}

const ssc_3_2of4 = () => { return [ tLab, renderCalendar, renderFinalExamTimes ] }

export const ssc_3_slidedeckTTR = [ ssc_3_1of2, ssc_3_2of4 ]